import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityState } from '@/shared/types/entity';
import { productsApi } from '../api';
import type { Product, ProductFormData, ProductSearchFilters } from '../types';

/**
 * Default filters for product search
 */
export const DEFAULT_PRODUCT_FILTERS: ProductSearchFilters = {
  search: '',
  dateRange: null,
  status: '',
  category: '',
  allowedSubscriptions: '',
  hasSwapConfigured: '',
  isOneOff: '',
  isLowOnStock: '',
  includeDeleted: '',
};

const initialState: EntityState<Product, ProductSearchFilters> = {
  items: [],
  loading: false,
  error: null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: { ...DEFAULT_PRODUCT_FILTERS },
};

const { actions, reducer } = createEntitySlice<Product, ProductSearchFilters, ProductFormData>({
  name: 'products',
  api: productsApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.products;
    return {
      page: currentPage,
      perPage,
      search: filters.search || undefined,
      status: filters.status || undefined,
      category: filters.category || undefined,
      allowedSubscriptions: filters.allowedSubscriptions || undefined,
      hasSwapConfigured: filters.hasSwapConfigured || undefined,
      isOneOff: filters.isOneOff || undefined,
      isLowOnStock: filters.isLowOnStock || undefined,
      includeDeleted: filters.includeDeleted || undefined,
    };
  },
});

export const {
  fetchItems: fetchProducts,
  createItem: createProduct,
  updateItem: updateProduct,
  deleteItem: deleteProduct,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
